export const DOMAIN =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test"
    ? window.location.origin || "https://www.cleartrip.com"
    : `http://localhost:3031`;
